// User role enumeration matching backend
export enum UserRole {
  SYSTEM_ADMIN = 'SYSTEM_ADMIN',
  UNIVERSITY_ADMIN = 'UNIVERSITY_ADMIN',
  FACULTY_ADMIN = 'FACULTY_ADMIN',
  PROFESSOR = 'PROFESSOR',
  COURSE_REPRESENTATIVE = 'COURSE_REPRESENTATIVE',
}

// Table data interfaces for UI components
export interface TenantTableData {
  id: string;
  name: string;
  description?: string;
  code?: string;
  createdAt: string;
}

export interface AdminUserTableData {
  id: string;
  name: string;
  email: string;
  role: string;
  assignedAt: string;
  userRoleId: string;
  userId: string;
  status?: 'active' | 'invited'; // Track if user has completed registration
}

// Form data interfaces
export interface TenantFormData {
  name: string;
  description?: string;
  code?: string;
}

export interface AdminInviteFormData {
  email: string;
  name?: string;
}
